import { handleActions } from 'redux-actions'
import * as rawActions from '../actions'
import { actualColumns } from '../services/enums'

const defaultState = actualColumns

export default handleActions(
  {
    [rawActions.setTableColumns](state, action) {
      return action.payload
    },
    [rawActions.getTenantContentsDashboardColumns.success](state, action) {
      const columns = action.response.data
      const existingPropNames = actualColumns.map((c) => c.PropName)
      const primaryColumns = columns
        .filter((col) => !col.IsCustom)
        .map((col) => {
          return {
            PropName: actualColumns.find((actCol) => actCol.CellTitle === col.Name).PropName,
            CellTitle: col.Name,
            Order: col.Order,
          }
        })

      const filteredPrimaryColumns = actualColumns.filter((actCol) => primaryColumns.includes(actCol.CellTitle))
      const existingCellTitles = filteredPrimaryColumns.map((c) => c.CellTitle)

      const mappedCustomColumns = columns
        .filter((col) => col.IsCustom)
        .map((col) => {
          let uniquePropName = col.Name

          let tempId = 1
          while (existingPropNames.includes(uniquePropName)) {
            uniquePropName = `${col.Name}_${tempId}`
            tempId++
          }

          existingPropNames.push(uniquePropName)

          let uniqueCellTitle = col.Name

          tempId = 1
          while (existingCellTitles.includes(uniqueCellTitle)) {
            uniqueCellTitle = `${col.Name}_${tempId}`
            tempId++
          }

          existingCellTitles.push(uniqueCellTitle)

          if (uniqueCellTitle !== col.Name) {
            uniqueCellTitle = `${uniqueCellTitle} ${`(${col.Name})`}`
          }

          const mappedCol = {
            PropName: uniquePropName,
            CellTitle: uniqueCellTitle,
            Order: col.Order,
          }

          return mappedCol
        })

      return [...primaryColumns, ...mappedCustomColumns].sort((a, b) => a.Order - b.Order)
    },
    [rawActions.resetState](state, action) {
      return defaultState
    },
  },
  defaultState
)
